<div class="page-header">
  <div>
    <h1>Zertifikatsvorlage</h1>
    <p>Hier kannst du die Vorlage austauschen, aus der neue Zertifikate erzeugt werden.</p>
  </div>

  <a class="ghost-button as-link" routerLink="/certificates">Zur Zertifikatsübersicht</a>
</div>

@if (template(); as item) {
  <section class="panel section-stack">
    <div class="panel-heading">
      <div>
        <h2>Aktuelle Vorlage</h2>
        <p>Die hinterlegte Vorlage wird für neue und noch nicht zwischengespeicherte Zertifikate verwendet.</p>
      </div>
      <div class="badge">{{ item.hasCustomTemplate ? 'Benutzerdefiniert' : 'Standard' }}</div>
    </div>

    <div class="data-grid compact">
      <span>Name</span>
      <strong>{{ item.name }}</strong>
      <span>Datei</span>
      <strong>{{ item.templatePdfFileName ?? 'DriveMe Standardvorlage' }}</strong>
      <span>Benutzerdefiniert</span>
      <strong>{{ item.hasCustomTemplate ? 'Ja' : 'Nein' }}</strong>
      <span>Aktualisiert</span>
      <strong>{{ formatDateTime(item.updatedAt) }}</strong>
    </div>
  </section>

  <section class="panel section-stack">
    <div class="panel-heading">
      <div>
        <h2>Vorlage bearbeiten</h2>
        <p>Vorlage austauschen, Namen anpassen oder auf die Standardvorlage zurücksetzen. Für echte Platzhalter-Ersetzung bitte eine editierbare `.docx`- oder `.odt`-Datei mit den vorgesehenen Platzhaltern verwenden.</p>
      </div>
    </div>

    <form class="dialog-form" (submit)="save($event)">
      <label class="full-width">
        <span>Vorlagenname</span>
        <input type="text" required [value]="form().name" (input)="updateForm('name', $event)">
      </label>

      <label class="full-width">
        <span>Beschreibung</span>
        <textarea rows="3" [value]="form().description" (input)="updateForm('description', $event)"></textarea>
      </label>

      <label class="full-width">
        <span>Vorlage</span>
        <input type="file" accept=".pdf,.docx,.odt,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text" (change)="selectTemplateFile($event)">
        <small>
          Für editierbare Word- oder ODT-Vorlagen müssen die Platzhalter <code>[Vorname Nachname]</code>, <code>[Kurs / Modul]</code>, <code>[TT.MM.JJJJ]</code>, <code>[95 %]</code>, <code>[DMA-M2-2026-XXXXXX]</code> und <code>[Verifizierungslink]</code> enthalten sein.
          @if (form().templatePdfFileName) {
            Neue Datei: {{ form().templatePdfFileName }}
          } @else if (item.templatePdfFileName) {
            Aktuelle Datei: {{ item.templatePdfFileName }}
          } @else {
            Keine benutzerdefinierte Datei hinterlegt. Es wird die Standardvorlage verwendet.
          }
        </small>
      </label>

      @if (notice()) {
        <p class="info-message full-width">{{ notice() }}</p>
      }

      <div class="dialog-actions full-width">
        <button type="submit" class="primary-button" [disabled]="saving()">
          {{ saving() ? 'Wird gespeichert...' : 'Vorlage speichern' }}
        </button>
        <button type="button" class="ghost-button" (click)="resetToDefault()" [disabled]="saving()">
          Auf Standard zurücksetzen
        </button>
        <button type="button" class="ghost-button" (click)="downloadTemplate()" [disabled]="downloading()">
          {{ downloading() ? 'Wird geladen...' : 'Vorlage herunterladen' }}
        </button>
      </div>
    </form>
  </section>
} @else {
  <div class="empty">Vorlage wird geladen.</div>
}
